<template>
  <div class="create-packorder" vkshop-event-scope="createPackorder">
    <div class="order-wrapper container">
      <table class="order-table">
        <thead>
          <tr>
            <th style="width:40%">商品</th>
            <th style="width:20%">当前宝贝</th>
            <th style="width:20%">数量</th>
            <th style="width:20%">价格</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="clearfixnew">
              <div class="cell">
                <img class="course-portrait fl" :src="imgSrc" alt />
                <div class="wrapper">
                  <div class="course-name">{{goodsGroup.goodsGroupName}}</div>
                  <div
                    class="promotion-module clearfix"
                    v-if="chooseCourse.promotionList && chooseCourse.promotionList.length !== 0"
                  >
                    <span class="sale-title">赠品:</span>
                    <ul class="option-items">
                      <template v-for="promotion in chooseCourse.promotionList">
                        <li
                          class="gift"
                          v-for="giftPackage in promotion.giftPackageList"
                          :key="giftPackage.giftPackageId"
                        >
                          <span>{{giftPackage.giftPackageName}}</span>
                          <span v-if="checkedGiftNumber(giftPackage.giftList)">（已赠完）</span>
                        </li>
                      </template>
                    </ul>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <span class="current-baby">{{studentInfo.name}}</span>
            </td>
            <td>
              <span class="course-num">X 1</span>
            </td>
            <td>
              <div class="cell">
                <div class="wrapper">
                  <span class="single-price">￥{{coursePack.nowPrice}}</span>
                  <div class="splitOrder" v-if="orderType === 'split'">
                    <span>拆分付：</span>
                    <ul>
                      <li v-for="(order, index) in orderList" :key="index">
                        <span class="orderIndex">第{{numberIndex[index]}}笔</span>
                        <span>￥{{order}}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="relation-tips" v-if="recommendationRewarded">
        <div class="relation-content">
          <div class="never-bind" v-if="!isrRelationshipBind">
            若有推荐人，请
            <a
              class="button-bind"
              href="javascript:;"
              @click="goBindMobilephone"
              vkshop-event-name="goBindMobilephone"
              vkshop-event-type="click"
            >填写推荐人手机号</a>
            以绑定
          </div>
          <div class="already-bind" v-if="isrRelationshipBind">
            <p>已绑定推荐人：{{this.mobileNumber}}，请继续完成购买！</p>
          </div>
        </div>
      </div>
      <div class="bottom-banner clearfixnew">
        <div
          class="buy-now fr"
          @click="submitPackorder"
          vkshop-event-name="submitPackorder"
          :vkshop-event-param="'studentId=' + studentId + '&coursePackId=' + id"
          vkshop-event-type="click"
        >确认购买</div>
        <div class="price fr">
          <span>合计</span>
          <span class="price-now">￥{{coursePack.nowPrice}}</span>
        </div>
      </div>
      <div class="order-tips">
        <p>!购买须知：</p>
        <p
          class="notice-content"
        >本课程有课程有效期限制，且退费需遵守退费规则，具体详见支付时签署的课程服务协议。如您选择了拆分付，则订单金额将自动拆分为多笔支付，每笔可单独支付，但订单不拆分，订单支付完成时间以拆分的每笔金额均支付完成时间为准。</p>
        <p
          class="notice-content"
        >请您在48小时内完成订单支付，逾期订单将自动取消；如您选择拆分金额付款，请您在48小时内完成第一笔金额支付，剩余金额须在7天内支付完成，逾期订单将自动取消。</p>
      </div>
    </div>
    <bindMobilephone
      :visible.sync="dialogVisible"
      :studentId="studentId"
      @mobilePhoneNo="mobilePhoneNo"
    />
  </div>
</template>
<script>
import bindMobilephone from "./bindMobilephone.vue";
export default {
  name: "order",
  data() {
    return {
      id: this.$route.params.id,
      groupId: this.$route.params.groupId,
      studentId: this.$route.params.studentId,
      orderType: this.$route.query.type,
      imgSrc: "",
      goodsGroup: {},
      coursePack: {},
      chooseCourse: {},
      studentInfo: {},
      orderList: [],
      numberIndex: ["一", "二", "三"],
      dialogVisible: false,
      recommendationRewarded: false,
      isrRelationshipBind: false,
      mobileNumber: ""
    };
  },
  components: {
    bindMobilephone
  },
  created() {
    const that = this;
    // 如果是拆单付，获取拆单金额
    if (this.orderType === "split") {
      this.axios({
        method: "get",
        url: "/mall/api/packorder/split",
        params: {
          coursePackId: this.id
        }
      }).then(response => {
        if (response.data && response.data.code == 200) {
          this.orderList = response.data.data;
        }
      });
    }
    this.axios({
      method: "get",
      url: "/mall/api/goodsGroup/display/details/id",
      params: {
        id: this.groupId
      }
    }).then(response => {
      if (response.data && response.data.code == 200) {
        this.goodsGroup = response.data.data;
        this.chooseCourse = this.goodsGroup.coursePackList[0];
        this.imgSrc = this.goodsGroup.urls[0];
      }
    });
    this.axios({
      method: "get",
      url: "/mall/api/coursePack/detail/id",
      params: {
        id: this.id,
        studentId: this.studentId
      }
    }).then(response => {
      if (response.data && response.data.code == 200) {
        this.coursePack = response.data.data;
      }
    });
    this.axios({
      method: "get",
      url: "/mall/api/userCenter/student/detail",
      params: {
        studentId: this.studentId
      }
    }).then(response => {
      if (response.data && response.data.code == 200) {
        this.studentInfo = response.data.data;
      }
    });
    this.axios({
      method: "get",
      url: "/mall/api/userCenter/rRelationship/judge",
      params: {
        studentId: this.studentId
      }
    }).then(response => {
      if (response.data && response.data.code == 200) {
        this.recommendationRewarded = response.data.data;
      }
    });
  },
  watch: {},
  methods: {
    submitPackorder() {
      let param = {};
      param.studentId = this.studentId;
      param.coursePackId = this.id;
      param.goodsGroupId = this.groupId;
      param.payType = 1
      if (this.orderType === "split") {
        param.hasSplit = true;
      } else {
        param.hasSplit = false;
      }

      this.axios({
        method: "post",
        url: "/mall/api/packorder/create",
        data: param
      }).then(res => {
        if (res.data.code == 200) {
          let payOrderId = res.data.data.payOrderId;
          if (res.data.data.hasFree === "true") {
            this.$router.push({
              name: "payResult",
              query: {
                orderId: payOrderId
              }
            });
          } else {
            this.$router.push({
              name: "orderPay",
              params: {
                payOrderId: payOrderId,
                orderType: 0,
                studentId: param.studentId
              },
              query: {
                from: "haoke"
              }
            });
          }

          // 由于跳页面，回导致埋点数据不准确，因此在订单支付页面加上&payFrom=shopPc，在神策查询的时候，通过地址查询payFrom，就可以知道点击数
          // location.href = `/parent/pingpay?orderId=${payOrderId}&orderType=0&studentId=${param.studentId}&payFrom=shopPc`
        } else if ([3005, 3040, 3042].includes(res.data.code)) {
          this.$alert(res.data.msg);
        } else if (res.data.code === 1028) {
          this.$confirm({
            content: res.data.data.msg,
            cancelBtnText: "取消",
            sureBtnText: "确定"
          })
            .then(() => {
              window.location.href = window.location.origin + res.data.data.url;
            })
            .catch(err => {});
        } else if (res.data.code === 1024) {
          this.$confirm({
            content: res.data.data.msg,
            cancelBtnText: "我的订单",
            sureBtnText: "去支付"
          })
            .then(() => {
              this.$router.push({ path: "/order/list" });
            })
            .catch(err => {
              this.$router.push({ path: "/order/list" });
            });
        }
      });
    },
    // 检查库存
    checkedGiftNumber(giftList) {
      return giftList.some(gift => {
        return gift.giftSellOut;
      });
    },
    //显示绑定推荐人手机号弹窗
    goBindMobilephone() {
      this.dialogVisible = true;
    },
    //将已经绑定完成的手机号传过来
    mobilePhoneNo(mobileNo) {
      this.mobileNumber = mobileNo;
      this.isrRelationshipBind = true;
    }
  }
};
</script>
<style lang="less">
.create-packorder {
  .order-wrapper {
    margin-top: 40px;
    font-size: 14px;
    padding: 0 30px;
  }
  .order-table {
    border-spacing: 1px;
    width: 100%;
    background: #fff;
    border-color: #e5e5e5;
    border-collapse: collapse;
    // border: none;
    thead {
      border-top: 1px solid #e5e5e5;
      border-bottom: 1px solid #e5e5e5;
      tr {
        background-color: #fff;
        height: 60px;
        text-align: left;
        th {
          padding-left: 24px;
        }
      }
    }
    tbody {
      tr {
        height: 148px;
        border-bottom: 1px solid #e5e5e5;
        .cell {
          height: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: table;
        }
        td {
          padding: 24px 0 24px 24px;
          .course-portrait {
            width: 100px;
            height: 100px;
            vertical-align: middle;
            margin-right: 24px;
          }
          .wrapper {
            display: table-cell;
            vertical-align: middle;
          }
          .course-name {
            font-size: 18px;
            color: #333;
            line-height: 25px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .promotion-module {
            margin-top: 8px;
            font-size: 12px;
            .sale-title {
              float: left;
              display: inline-block;
              line-height: 17px;
              margin-right: 8px;
              color: #999;
            }
            .option-items {
              max-width: 530px;
              float: left;
              line-height: 17px;
              li {
                span {
                  color: #999;
                }
                display: inline-block;
                margin-right: 18px;
              }
            }
          }
          .splitOrder {
            line-height: 17px;
            span {
              font-size: 12px;
              color: #999;
            }
            .orderIndex {
              margin-right: 8px;
              display: inline-block;
            }
          }
          .single-price {
            height: 25px;
            font-size: 18px;
            font-weight: 600;
            color: #f85415;
            line-height: 25px;
          }
          .course-num {
            height: 25px;
            font-size: 18px;
            line-height: 25px;
          }
          .current-baby {
            height: 25px;
            font-size: 18px;
            line-height: 25px;
          }
        }
      }
    }
  }
  .relation-tips {
    font-size: 12px;
    color: #333;
    margin-top: 10px;
    .relation-content {
      text-indent: 2em;
      .button-bind {
        cursor: pointer;
        color: #3a7ff2;
        &:hover {
          color: #1760d7;
        }
      }
    }
  }
  .bottom-banner {
    background: #f8f8f8;
    height: 60px;
    line-height: 60px;
    margin-top: 32px;
    margin-bottom: 16px;
    .price {
      span {
        color: #999;
        display: table-cell;
      }
      .price-now {
        font-size: 24px;
        font-weight: 600;
        color: #f85415;
        vertical-align: middle;
        padding-left: 12px;
      }
    }
    .buy-now {
      width: 210px;
      height: 60px;
      background: #f85415;
      text-align: center;
      line-height: 60px;
      color: #fff;
      margin-left: 40px;
      font-size: 18px;
      cursor: pointer;
      &:hover {
        background: #e64507;
        -webkit-box-shadow: 0 0 10px 0 rgba(255, 103, 26, 0.3),
          0 5px 10px 0 rgba(255, 103, 26, 0.6);
        box-shadow: 0 0 10px 0 rgba(255, 103, 26, 0.3),
          0 5px 10px 0 rgba(255, 103, 26, 0.6);
      }
    }
  }
  .order-tips {
    font-size: 12px;
    color: #333;
    margin-bottom: 40px;
    .notice-content {
      text-indent: 2em;
    }
    p {
      line-height: 17px;
    }
  }
}
</style>

